<template>
    <div class="radiotherapy-container">
        <div class="calendar-container">
            <div class="yyyy-MM" >
                <span class="date" @click="DateMMShow = true">{{getLocalMonth(dateTxt).replace(/\//, '年')}}月</span>
                <span class="all" @click="seeDetail">{{$t("radiotherapy.all")}}</span>
            </div>
            <div class=""  @touchstart="touchstart" @touchmove="touchmove">
                <calendar :defaultTime="dateTxt" :reserveDate="dateRaduitgerapy" :touchObj="{isDirection,touchProcess}" :setprojectResult="setprojectResult" />
            </div>
        </div>
        <div class="radiotherapy-patient" v-if="patientList.date">
            <div class="patient-item" v-for="(item,index) in patientList.patients" :key="index" >
                <div class="item-head">
                    <p class="txt">{{item.patientName}}</p>
                    <p class="time">
                        <span>{{item.timeRange}}</span>
                    </p>
                </div>
                <div class="item-info">
                    <div class="info">
                        <p class="info-time">
                            <span class="label">
                                {{$t("radiotherapy.planTime")}}：
                            </span>
                            <span class="value">
                                {{patientList.date}}
                            </span>
                        </p>
                        <p class="info-compuyrRoom">
                            <span class="label">
                                {{$t("radiotherapy.treatmentRoom")}}：
                            </span>
                            <span class="value">
                                {{item.checkRoomName}}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <my-overlay :show="DateMMShow" :showField="'DateMMShow'">
            <van-datetime-picker
                v-model="DateRange"
                type="year-month"
                :title='$t("patient.pleaseselect")'
                slot="overBox"
                :min-date="minDate"
                @cancel="DateMMShow = false"
                :max-date="maxDate"
                @confirm="monthConfirm"
            />
        </my-overlay>
    </div>
</template>

<script>
import myOverlay from "@/components/myoverlay"
import calendar from "./components/calendar.vue"
import { getLocalMonth } from "@/utils/date"
import { radiotherapyQuery } from "@/api/user";
export default {
    components:{
        myOverlay,
        calendar
    },
    data () {
        return {
            maxDate: new Date(new Date().getFullYear()+5, 0, 1),
            minDate: new Date(new Date().getFullYear()-5, 0, 1),
            DateRange:new Date(),
            dateTxt:'',
            patientList:{},
            dateRaduitgerapy:[],
            getLocalMonth,
            startX:0,
            startY:0,
            moveX:0,
            moveY:0,
            // 左右方向 1 右滑触发 2 左滑触发
            isDirection:null,
            touchProcess:false,
            DateMMShow:false
        }
    },
    created () {
        this.dateTxt = getLocalMonth( new Date().getFullYear() + '-'+(new Date().getMonth()+1))+'/'+new Date().getDate();
        this.getDateQuery();
        document.title = this.$t("radiotherapy.name")
    },
    methods: {
        getDateQuery(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            radiotherapyQuery({}).then(res =>{
                this.dateRaduitgerapy = res.data.data;
                let min,max;
                for (let i = 0; i < this.dateRaduitgerapy.length; i++) {
                    const it = this.dateRaduitgerapy[i];
                    if(!min){
                        min = new Date(it.date).getTime();
                    }else if(min&&new Date(min).getTime() > new Date(it.date).getTime()){
                        min = new Date(it.date).getTime();
                    }
                    if(!max){
                        max = new Date(it.date).getTime();
                    }else if(max&&max){
                        max = new Date(it.date).getTime();
                    }
                }
                this.minDate = new Date(min);
                this.maxDate = new Date(max);
                if(new Date(new Date(min).getFullYear()+"/"+(new Date(min).getMonth()+1)+"/1").getTime() >= new Date(getLocalMonth( new Date().getFullYear() + '/'+(new Date().getMonth()+1))+'/'+new Date().getDate()).getTime()){
                    this.dateTxt = new Date(min).getFullYear()+"/"+(new Date(min).getMonth()+1)+"/1";
                }
                if(new Date(new Date(max).getFullYear()+"/"+(new Date(max).getMonth()+1)+"/1") <= new Date(getLocalMonth( new Date().getFullYear() + '/'+(new Date().getMonth()+1))+'/'+new Date().getDate()).getTime()){
                    this.dateTxt = new Date(max).getFullYear()+"/"+(new Date(max).getMonth()+1)+"/1"
                }
                setTimeout(()=>{
                    toast.clear()
                },100)
                console.log(this.dateTxt);
            })
        },
        touchstart(e) {
            // 如果你要阻止点击事件，请反注释下一行代码
            // e.preventDefault()
            this.startX = e.touches[0].clientX;
            this.isDirection = null;
            this.startY = e.touches[0].clientY;
        },
        touchmove(e) {
            // e.preventDefault()
            this.moveX = e.touches[0].clientX;
            this.moveY = e.touches[0].clientY;
            //   this.startX - this.moveX <= 0
            //     ? console.log("你在往右滑")
            //     : console.log("你在往左滑");
            
            let nowTime = new Date(new Date(this.dateTxt).getFullYear()+"/"+(new Date(this.dateTxt).getMonth()+1)+"/1").getTime()
            let minTime = new Date(new Date(this.minDate).getFullYear()+"/"+ (new Date(this.minDate).getMonth()+1)+"/1").getTime();
            let maxTime = new Date(new Date(this.maxDate).getFullYear()+"/"+ (new Date(this.maxDate).getMonth()+1)+"/1").getTime();
            if (this.startX - this.moveX <= -60) {
                if(nowTime == minTime){
                    return false;
                }
                if(!this.touchProcess){
                    this.touchProcess = true;
                    let year = new Date(this.dateTxt).getFullYear();
                    let month = (new Date(this.dateTxt).getMonth()+1);
                    this.dateTxt = year + '/' + (month-1) +'/1';
                    if(month == 1){
                        this.dateTxt = (year-1) + '/12/1';
                    }
                    this.isDirection = 1;
                    setTimeout(()=>{
                        this.touchProcess = false;
                    },500)
                }
                // 右滑触发
                // do something
            }
            if (this.startX - this.moveX >= 60) {
                // 左滑触发
               if(nowTime == maxTime){
                    return false;
                }
                if(!this.touchProcess){
                    this.touchProcess = true;
                    let year = new Date(this.dateTxt).getFullYear();
                    let month = (new Date(this.dateTxt).getMonth()+1);
                    this.dateTxt = year + '/' + (month+1) + '/1';
                    if(month == 12){
                        this.dateTxt = (year+1) + '/1/1';
                    }
                    this.isDirection = 2;
                    setTimeout(()=>{
                        this.touchProcess = false;
                    },500)
                }
                // do something
            }
        },
        monthConfirm(e){
            this.dateTxt =  getLocalMonth(new Date(e).getFullYear() + '-'+(new Date(e).getMonth()+1))+'/'+new Date(e).getDate();
            this.DateMMShow = false;
        },
        setprojectResult(r){
            this.patientList = r;
        },
        seeDetail(){
            console.log(this.$store);
            this.$router.push({
                path:"/radiotherapy/detail",
                query:{
                    // patientId:this.$store.getters.id
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.radiotherapy-container{
    height: 100%;
    overflow: auto;
    background: #f5f5f5;
    .calendar-container{
        background: #fff;
        padding: 0.6rem 0.6rem 0 0.6rem;
        margin: 0.2rem 0;
        .yyyy-MM{
            height: 1.2rem;
            line-height: 1.2rem;
            font-size: 0.72rem;
            font-weight: 500;
            line-height: 1.2rem;
            margin-bottom: 0.4rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #333333;
            .date{
                // flex: 1;
                // margin-right: 0.4rem;
                position: relative;
                &::after{
                    position: absolute;
                    content: ' ';
                    right: -0.6rem;
                    border: 0.25rem solid transparent;
                    border-top: 0.25rem solid #49A7FF;
                    top: 75%;
                    transform: translate(0,-50%);
                }
            }
            .all{
                font-size: 0.6rem;
                color:#49A7FF;
                padding: 0.2rem;
            }
        }
    }
    .radiotherapy-patient{
        overflow: auto;
        margin: 0.6rem;
        .patient-item{
            margin-bottom: 0.6rem;
            background: #FFFFFF;
            border-radius: 0.16rem;
            .item-head{
                height: 1.6rem;
                position: relative;
                background: url("~@/assets/img/rediotherapy-patient-title.png") no-repeat;
                padding: 0 0.8rem;
                background-size: 100% 100%;
                .txt{
                    line-height: 1.6rem;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background-size: 100% 100%;
                    // text-overflow: ellipsis;
                    white-space: nowrap;
                    padding-right: 4.25rem;
                    font-size: 0.72rem;
                    font-weight: 500;
                    color: #333333;
                    
                }
                .time{
                    position: absolute;
                    height: 100%;
                    width: 6rem;
                    right: 0;
                    top: 0;
                    font-size: 0.64rem;
                    font-weight: 500;
                    color: #333333;
                    text-align: right;
                    line-height: 1.6rem;
                    background: url("~@/assets/img/patient-title-time.png") no-repeat;
                    background-size: 100% auto;
                    span{
                        margin-right: 0.8rem;
                    }
                }
            }
            .item-info{
                padding: 0.6rem 0.8rem;
                .info{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 0.56rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #606266;
                    align-items: flex-start;
                    .info-time{
                        flex: 1;
                        align-items: center;
                    }
                    .info-compuyrRoom{
                        flex: 1;
                        align-items: flex-start;
                    }
                    p{
                        display: flex;
                        .label{
                            flex: 0 0 auto;
                        }
                        .value{
                            flex: 1;
                        }
                    }
                }
            }
        }
    }
}
</style>